import { round } from 'lodash';
import React from 'react';import PrimaryButton from '../ui/PrimaryButton';

function createFragment(htmlStr:string) {
  const frag = document.createDocumentFragment();
  const temp = document.createElement('div');

  temp.innerHTML = htmlStr;

  while (temp.firstChild) {
    frag.appendChild(temp.firstChild);
  }

  return frag;
}

function TableHeaderSizeDisplay() {
  function createTooltipWithSize(h: HTMLDivElement) {
    const r = h.getBoundingClientRect();
    const w = round(r.width, 2);

    const tooltip = document.getElementById(`${h.id}-size-tooltip`);
    if (tooltip) {
      return;
    }

    const fragment = createFragment(`<div id="${h.id}-size-tooltip" class="ifms-tooltip-tb-header">${w}</div>`);

    const firstChildNode = fragment.childNodes[0];
    if (!(firstChildNode instanceof HTMLElement)) {
      return;
    }

    firstChildNode.style.left = `${r.left}px`;
    firstChildNode.style.top = `${r.top - 20}px`;

    document.body.appendChild(fragment.childNodes[0]);
  }

  function show() {
    const sizes = document.querySelectorAll('.ifms-tooltip-tb-header');
    if (sizes.length > 0) {
      for (let i = 0; i < sizes.length; ++i) {
        const t = sizes[i];
        if (t.parentElement) {
          t.parentElement.removeChild(t);
        }
      }

      return;
    }
    const headers = document.querySelectorAll('div[role="columnheader"]') as NodeListOf<HTMLDivElement>;

    headers.forEach(createTooltipWithSize);
  }

  return (
    <PrimaryButton onClick={show} style={{width: '120px', height: '30px', position: 'absolute', bottom: 40, right: 130}}>
      Show/Hide
    </PrimaryButton>
  );
}

export default React.memo(TableHeaderSizeDisplay);